/* prompt:

[{ "type": "wday", "wday": "sunday", "intervals": [ {from: '11:00', to: '17:00'}] }...] 
 JS, add to the object list, a timeslot array of 30min time slots between the intervals hours. 
 ie ['11.30am', '12.00pm', ...]
*/

/**
 * Helper function to format a Date object as 'HH:mm am/pm'.
 * @param {Date} date The date object to format.
 * @returns {string} The formatted time string.
 */
function formatTime(date) {
  let hours = date.getHours()
  let minutes = date.getMinutes()
  const ampm = hours >= 12 ? 'pm' : 'am'
  hours = hours % 12
  hours = hours ? hours : 12 // the hour '0' should be '12'
  minutes = minutes < 10 ? '0' + minutes : minutes
  return hours + ':' + minutes + ampm
}

/**
 * Generates an array of 30-minute time slots between a start and end time.
 * @param {string} startTimeStr The start time string (e.g., '09:00').
 * @param {string} endTimeStr The end time string (e.g., '17:00').
 * @returns {Array<string>} An array of formatted time slots.
 */
function generateIntervalSlots(startTimeStr, endTimeStr) {
  const slots = []
  const today = new Date()
  const start = new Date(today.toDateString() + ' ' + startTimeStr)
  const end = new Date(today.toDateString() + ' ' + endTimeStr)

  let currentTime = start
  while (currentTime < end) {
    //@ts-ignore
    slots.push(formatTime(currentTime))
    currentTime = new Date(currentTime.getTime() + 30 * 60000) // Add 30 minutes
  }
  return slots
}

/**
 * Adds a collective timeslots array to each day object, as a sibling to the intervals array.
 * @param {Array<Object>} schedule The schedule array with wday and intervals properties.
 * @returns {Array<Object>} The updated schedule array with the collective timeslots.
 */
export function addCollectiveTimeSlots(schedule) {
  // Iterate over each day in the schedule
  schedule.forEach((day) => {
    let allDaySlots = []

    // Iterate over each interval for that day and generate slots
    day.intervals.forEach((interval) => {
      const intervalSlots = generateIntervalSlots(interval.from, interval.to)
      allDaySlots = allDaySlots.concat(intervalSlots)
    })

    // Add the combined time slots array to the day object (sibling of intervals)
    day.timeslots = allDaySlots
  })

  return schedule
}
